import script from "./IdCardBobineReading.vue?vue&type=script&setup=true&lang=js"
export * from "./IdCardBobineReading.vue?vue&type=script&setup=true&lang=js"

const __exports__ = script;

export default __exports__